import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface ConfirmAddressValidationDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmAddressValidationDialog({
  open,
  onConfirm,
  onCancel,
}: Readonly<ConfirmAddressValidationDialogProps>) {
  return (
    <Dialog open={open} onClose={onCancel} aria-labelledby="address-validation-title">
      <DialogTitle id="address-validation-title">Address could not be verified</DialogTitle>
      <DialogContent>
        <DialogContentText>
          We were unable to verify this address. Please double-check the street
          address, city, state, and ZIP code. You can still save if the address is
          correct.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Go back</Button>
        <Button onClick={onConfirm} variant="contained">
          Save anyway
        </Button>
      </DialogActions>
    </Dialog>
  );
}
